import { TPasskeyItem } from "@/api/services/main/auth/dtos/passkey.dto";
import { passkeySchema, TPasskeyForm } from "@/components/commons/PasskeyManager/passkeySchema";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Modal } from "@/components/elements/Modal";
import { text } from "@/theme/colors";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";

type TRenamePasskeyModalProps = {
  target: TPasskeyItem | null;
  isSaving: boolean;
  onOk: (deviceName: string) => void;
  onClose: () => void;
};

export const RenamePasskeyModal: FC<TRenamePasskeyModalProps> = ({ target, isSaving, onOk, onClose }) => {
  const methods = useForm<TPasskeyForm>({
    defaultValues: { deviceName: "" },
    resolver: yupResolver(passkeySchema),
    mode: "all",
    reValidateMode: "onBlur",
  });
  const { control, reset } = methods;

  useEffect(() => {
    if (target) reset({ deviceName: target.deviceName ?? "" });
  }, [target, reset]);

  const handleValid = ({ deviceName }: TPasskeyForm) => onOk(deviceName.trim());

  return (
    <Modal
      isOpen={!!target}
      title="パスキーの名前を変更"
      labelOk="変更する"
      labelClose="キャンセル"
      isLoadingOkBtn={isSaving}
      onOk={methods.handleSubmit(handleValid)}
      onClose={onClose}
    >
      <Stack gap={4} py="8px" mb="16px" width={360}>
        <Typography variant="body14" color={text.secondary} whiteSpace="nowrap">
          このパスキーを識別しやすいデバイス名に変更できます。
        </Typography>
        <Form methods={methods} onSubmit={handleValid} enableBlocker={false} schema={passkeySchema}>
          <FormField control={control} name="deviceName">
            <Input size="lg" placeholder="入力してください" />
          </FormField>
        </Form>
      </Stack>
    </Modal>
  );
};
